import ROUTE_NAMES from '@/vue/routes/routeNames';
import SECTION_NAMES from '@/vue/routes/sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';
import CircuitIcon from '@/images/circuit.svg?component';

const meta = {
    title: SECTION_NAMES.CIRCUIT,
    icon: CircuitIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminCircuit],
};

const CircuitEdit = () => import('./views/CircuitEdit.vue');

export default [
    {
        path: 'cue/circuit',
        name: ROUTE_NAMES.ADMIN_CIRCUIT,
        redirect: { name: ROUTE_NAMES.ADMIN_CIRCUIT_LIST },
        meta,
        children: [
            {
                path: 'list',
                name: ROUTE_NAMES.ADMIN_CIRCUIT_LIST,
                component: () => import('./views/CircuitList.vue'),
                meta,
            },
            {
                path: 'new',
                name: ROUTE_NAMES.ADMIN_CIRCUIT_NEW,
                component: CircuitEdit,
                meta,
            },
            {
                path: ':id/edit',
                name: ROUTE_NAMES.ADMIN_CIRCUIT_EDIT,
                component: CircuitEdit,
                meta,
            },
            {
                path: ':id/view',
                name: ROUTE_NAMES.ADMIN_CIRCUIT_VIEW,
                props: true,
                component: () => import('./views/CircuitView.vue'),
                meta,
            },
        ],
    },
];
